import { Box, styled } from "@mui/material";

export const StyledCreateInvoiceForm = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "50rem",
  paddingTop: "1rem",
  ".invoiceWrapper": {
    boxSizing: "border-box",
    padding: "5rem",
    width: "70rem",
    height: "auto",
    minHeight: "100rem",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    boxShadow: `0px 0px 3px 3px ${theme.contrast.shadowColor}`,
    margin: "auto",
    borderRadius: "5px",
    ".invoiceHeader": {
      display: "flex",
    },
    ".invoiceData": {
      display: "flex",
      width: "100%",
      borderRadius: "5px",
      flexDirection: "column",
      overflow: "hidden",
      border: `2px solid ${theme.contrast.lighter}`,
      ".head": {
        display: "flex",
        width: "100%",
        background: theme.color.main,
        h4: {
          width: "25%",
          color: theme.color.background,
          height: "3rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
        },
      },
      ".data": {
        display: "flex",
        width: "100%",
        h4: {
          width: "25%",
          height: "3rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          color: theme.contrast.dark,
        },
      },
    },
    ".invoiceFooter": {
      ".vatTable": {
        display: "flex",
        flexDirection: "column",
        borderRadius: "5px",
        overflow: "hidden",
        ".row": {
          display: "flex",
          width: "100%",
          gap: "1rem",
        },
        ".block": {
          width: "20%",
          height: "1.5rem",
        },
        h5: {
          display: "flex",
          fontWeight: "bold",
          justifyContent: "space-between",
          boxSizing: "border-box",
          paddingInline: "1rem",
          alignItems: "center",
        },
        ".title": {
          textAlign: "start",
        },
        ".data": {
          color: theme.contrast.main,
        },
        ".totals": {
          background: theme.color.dark,
          color: theme.color.background,
        },
        ".head": {
          textAlign: "center",
          padding: "0",
          display: "block"
        },
      },
    },
  },
}));
